module.exports = __webpack_public_path__ + "assets/img/logo-bottom.03737768.png";